module.exports = "pegasus/assets/theme6/l_w.png";